import React, { useState } from 'react';
import { bugAPI } from '../services/api';
import './ReportBugModal.css';

function ReportBugModal({ isOpen, onClose }) {
  const [formData, setFormData] = useState({
    title: '',
    email: '',
    description: ''
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    // Validate required fields
    if (!formData.title.trim() || !formData.description.trim()) {
      setError('Please provide both a title and description');
      setLoading(false);
      return;
    }

    try {
      await bugAPI.create(formData);
      setSuccess(true);
      
      // Reset form after 2 seconds and close modal
      setTimeout(() => {
        setFormData({ title: '', email: '', description: '' });
        setSuccess(false);
        onClose();
      }, 2000);
    } catch (err) {
      setError(err.response?.data?.message || 'Failed to submit bug report. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  const handleClose = () => {
    if (!loading) {
      setFormData({ title: '', email: '', description: '' });
      setError('');
      setSuccess(false);
      onClose();
    }
  };

  if (!isOpen) return null;

  return (
    <div className="modal-overlay" onClick={handleClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h2>🐛 Report a Bug</h2>
          <button 
            className="modal-close-btn" 
            onClick={handleClose}
            disabled={loading}
            aria-label="Close modal"
          >
            ×
          </button>
        </div>

        {success ? (
          <div className="success-message">
            <p>✅ Thank you! Your bug report has been submitted successfully.</p>
          </div>
        ) : (
          <form onSubmit={handleSubmit} className="bug-form">
            {error && <div className="error-message">{error}</div>}
            
            <div className="form-group">
              <label htmlFor="title">
                Title <span className="required">*</span>
              </label>
              <input
                type="text"
                id="title"
                name="title"
                value={formData.title}
                onChange={handleChange}
                placeholder="Brief description of the issue"
                required
                disabled={loading}
              />
            </div>

            <div className="form-group">
              <label htmlFor="email">
                Email <span className="optional">(Optional)</span>
              </label>
              <input
                type="email"
                id="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                placeholder="Your email (if you'd like feedback)"
                disabled={loading}
              />
              <small>Leave blank if you prefer to remain anonymous</small>
            </div>

            <div className="form-group">
              <label htmlFor="description">
                Description <span className="required">*</span>
              </label>
              <textarea
                id="description"
                name="description"
                value={formData.description}
                onChange={handleChange}
                placeholder="What were you trying to do? What happened? What did you expect to happen?"
                rows="6"
                required
                disabled={loading}
              />
              <small>Please be as detailed as possible</small>
            </div>

            <div className="form-actions">
              <button 
                type="button" 
                className="btn btn-secondary" 
                onClick={handleClose}
                disabled={loading}
              >
                Cancel
              </button>
              <button 
                type="submit" 
                className="btn btn-primary" 
                disabled={loading}
              >
                {loading ? 'Submitting...' : 'Submit Bug Report'}
              </button>
            </div>
          </form>
        )}
      </div>
    </div>
  );
}

export default ReportBugModal;
